var _defs, _rect, _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMacuLogoRedNot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 432.6 290.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6280f;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.32,
    width: 287.96,
    height: 57.93
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "130.73 288.32 130.73 108.37 72.81 108.37 72.81 269.5 130.73 288.32"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.26 108.37 187.34 108.37 187.34 245.83 245.26 223.6 245.26 108.37"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "359.79 108.37 301.87 108.37 301.87 288.34 359.79 262.55 359.79 108.37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacuLogoRedNot);
export default __webpack_public_path__ + "static/media/MACU_Logo_Red_NOT.b32b6c1d1ddc78815aa7f4fb096391cb.svg";
export { ForwardRef as ReactComponent };